/* eslint-disable import/no-unresolved */
import React from 'react';
import * as unthemed from '@bingads-webui-react/primitive-unthemed';
import { IDropdownComponent } from './types';
import { withStyleOverride } from './with-style-override';
import { withCustomClassName } from './with-custom-class-name';

export {
  Grid,
  Row,
  Col,
  Form,
  FormGroup,
  ButtonGroup,
  ButtonToolbar,
  Panel,
  PanelGroup,
} from '@bingads-webui-react/layout';

export const Alert = withStyleOverride(unthemed.Alert as React.ComponentType<any>, ['components.alert']);
export const Label = withStyleOverride(unthemed.Label as React.ComponentType<any>, ['components.label']);
export const Button = withStyleOverride(unthemed.Button, ['components.button']);
export const Radio = withStyleOverride(unthemed.Radio as React.ComponentType<any>, ['components.radio']);
export const Checkbox = withStyleOverride(unthemed.Checkbox as React.ComponentType<any>, ['components.checkbox']);
export const Input = withStyleOverride(unthemed.Input, ['components.input']);
export const Select = withStyleOverride(unthemed.Select, ['components.select']);
export const TextArea = withStyleOverride(unthemed.TextArea, ['components.textarea']);
export const Glyphicon = withStyleOverride(
  unthemed.Glyphicon as React.ComponentType<React.ComponentProps<typeof unthemed.Glyphicon> & { title?: string }>,
  ['components.glyphicon']
);

export const Dropdown = withStyleOverride(unthemed.Dropdown as React.ComponentType<any>, ['components.dropdown']) as unknown as IDropdownComponent;
export const DropdownToggle = withCustomClassName(unthemed.Dropdown.Toggle as React.ComponentType<any>, 'react-dropdown-toggle', 'toggle');
export const DropdownMenu = withCustomClassName(unthemed.Dropdown.Menu as React.ComponentType<any>, 'react-dropdown-menu', 'menu');
export const DropdownButton = withStyleOverride(unthemed.DropdownButton as React.ComponentType<any>, ['components.dropdownbutton']);

(Dropdown as IDropdownComponent).Toggle = DropdownToggle;
(Dropdown as IDropdownComponent).Menu = DropdownMenu;

export const MenuItem = withStyleOverride(unthemed.MenuItem as React.ComponentType<any>, ['components.menuitem']);
export const Modal = withStyleOverride(unthemed.Modal, ['components.modal']);
export const Tooltip = withStyleOverride(unthemed.Tooltip as React.ComponentType<any>, ['components.tooltip']);
export const { OverlayTrigger, Overlay } = unthemed;
export const Popover = withStyleOverride(unthemed.Popover as React.ComponentType<any>, ['components.popover']);
export const Navbar = withStyleOverride(unthemed.Navbar, ['components.navbar']);
export const Nav = withStyleOverride(unthemed.Nav as React.ComponentType<any>, ['components.nav']);

export const NavDropdown = withCustomClassName(withStyleOverride(unthemed.NavDropdown as React.ComponentType<any>, ['components.navdropdown']), 'react-dropdown');

export const NavItem = withStyleOverride(unthemed.NavItem as React.ComponentType<any>, ['components.navitem']);
export const Image = withStyleOverride(unthemed.Image as React.ComponentType<any>, ['components.image']);
export const Tabs = withStyleOverride(unthemed.Tabs as React.ComponentType<any>, ['components.tabs']);
export const Tab = withStyleOverride(unthemed.Tab as React.ComponentType<any>, ['components.tab']);
